import { render } from "./HomeLayout.vue?vue&type=template&id=e8f4caa2"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
script.render = render

export default script